// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CompletedTaskBudgetReviewWidgetQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CompletedTaskBudgetReviewWidgetQuery = { __typename?: 'Query', projectCompletedTaskBudgetReview: Array<{ __typename?: 'ProjectCompletedTaskBudgetReview', bucket: string, costInCents: number }> };


export const CompletedTaskBudgetReviewWidgetDocument = gql`
    query CompletedTaskBudgetReviewWidget($projectId: ID!) {
  projectCompletedTaskBudgetReview(projectId: $projectId) {
    bucket
    costInCents
  }
}
    `;

/**
 * __useCompletedTaskBudgetReviewWidgetQuery__
 *
 * To run a query within a React component, call `useCompletedTaskBudgetReviewWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedTaskBudgetReviewWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedTaskBudgetReviewWidgetQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCompletedTaskBudgetReviewWidgetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables> & ({ variables: CompletedTaskBudgetReviewWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>(CompletedTaskBudgetReviewWidgetDocument, options);
      }
export function useCompletedTaskBudgetReviewWidgetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>(CompletedTaskBudgetReviewWidgetDocument, options);
        }
// @ts-ignore
export function useCompletedTaskBudgetReviewWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>;
export function useCompletedTaskBudgetReviewWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CompletedTaskBudgetReviewWidgetQuery | undefined, CompletedTaskBudgetReviewWidgetQueryVariables>;
export function useCompletedTaskBudgetReviewWidgetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>(CompletedTaskBudgetReviewWidgetDocument, options);
        }
export type CompletedTaskBudgetReviewWidgetQueryHookResult = ReturnType<typeof useCompletedTaskBudgetReviewWidgetQuery>;
export type CompletedTaskBudgetReviewWidgetLazyQueryHookResult = ReturnType<typeof useCompletedTaskBudgetReviewWidgetLazyQuery>;
export type CompletedTaskBudgetReviewWidgetSuspenseQueryHookResult = ReturnType<typeof useCompletedTaskBudgetReviewWidgetSuspenseQuery>;
export type CompletedTaskBudgetReviewWidgetQueryResult = ApolloReactCommon.QueryResult<CompletedTaskBudgetReviewWidgetQuery, CompletedTaskBudgetReviewWidgetQueryVariables>;